import { render, staticRenderFns } from "./AvCard.vue?vue&type=template&id=71b11c96&scoped=true"
import script from "./AvCard.vue?vue&type=script&lang=ts"
export * from "./AvCard.vue?vue&type=script&lang=ts"
import style0 from "./AvCard.vue?vue&type=style&index=0&id=71b11c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b11c96",
  null
  
)

export default component.exports